// extracted by mini-css-extract-plugin
module.exports = {"Body":"cookie_Body__9x5mH","fadeIn":"cookie_fadeIn___oWJo","Title":"cookie_Title___OskC"};